import React from 'react';
import {
  ErrorBanner,
  HelplinePhoneNumber,
  Paragraph,
  PhoneLink,
  StackedColumn,
  StackedRow,
  StackedRowSpacing,
} from '../../core';

interface GenericErrorProps {
  errorCode?: string;
}

const GenericError: React.FC<GenericErrorProps> = (
  props: GenericErrorProps
) => {
  return (
    <ErrorBanner
      title="Something went wrong."
      content={
        <StackedColumn>
          <div>
            <Paragraph text="Please try again, or contact the Marshfield Clinic Health System HelpLine at " />
            <PhoneLink phoneNumber={HelplinePhoneNumber} includeImage={false} />
          </div>
          {props.errorCode ? (
            <StackedRow spacing={StackedRowSpacing.Tight}>
              <Paragraph text="Please provide the support representative with this error code:" />
              <Paragraph text={props.errorCode} />
            </StackedRow>
          ) : null}
        </StackedColumn>
      }
    />
  );
};

export default GenericError;
